import Logo from "components/logo";
import styled from "styled-components";

const Navbar = () => {
  return (
    <Container>
      <Logo width="8rem" />
    </Container>
  );
};

export default Navbar;

const Container = styled.div`
  width: 100%;
  padding: 1.4rem 4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #0d0d0d;
  position: relative;
  z-index: 10;
`;
